export default __webpack_public_path__ + "static/media/reply.5ce91d27.svg";